import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/IngestTasks/IngestTask'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/IngestTasks/IngestTask'
import { mediaPlatformIngestTasksRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/IngestTasks/Routing'

export const mediaPlatformIngestTaskRoute = createRoute({
  getParentRoute: () => mediaPlatformIngestTasksRoute,
  path: DynamicRouteParameterWPrefix.INGEST_TASK_ID,
  loader: () => ({
    crumb: t('entity:publishing.ingestTask', { count: 1 }),
  }),
})

export const mediaPlatformIngestTaskLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformIngestTaskRoute,
  id: 'mediaPlatforIngestTaskLayout',
  component: Structure,
})

export const mediaPlatformIngestTaskRawRoute = createRoute({
  getParentRoute: () => mediaPlatformIngestTaskLayoutRoute,
  path: '/',
  component: Overview,
})
